import { LGoCard, LGoCardContent, LGoCardHeader, LGoCardTitle } from "@/ui/branded";
import { Switch } from "@/ui/primitives/switch";
import type { PushNotificationState } from "@/features/settings/hooks/usePushNotifications";

export interface PushNotificationsSectionProps {
  state: PushNotificationState;
  isSwitching: boolean;
  onEnable: () => void;
  onDisable: () => void;
}

const explanations: Record<PushNotificationState, string> = {
  loading: "Zjišťujeme, jak je na tom váš prohlížeč…",
  on: "Zapnuto. Žádost o potvrzení rezervace vám dorazí i se zavřeným portálem. Kliknutím na upozornění otevřete rezervaci.",
  off: "Vypnuto. O rezervacích se dozvíte jen e-mailem a po otevření portálu.",
  blocked:
    "Váš prohlížeč upozornění pro tento web zakázal, takže je odsud zapnout nemůžeme. Povolte je v nastavení prohlížeče a načtěte stránku znovu.",
  unsupported:
    "Tento prohlížeč upozornění neumí. Otevřete portál v jiném prohlížeči, nebo se spolehněte na e-mail.",
  "needs-install":
    "Na iPhonu přidejte portál na plochu: Sdílet → Přidat na plochu. Potom oznámení zapnete tady.",
};

export function PushNotificationsSection({
  state,
  isSwitching,
  onEnable,
  onDisable,
}: PushNotificationsSectionProps) {
  // A switch that cannot move must not look as if it could — a blocked or
  // unsupported browser is a fact about the browser, not a setting.
  const isSwitchable = state === "on" || state === "off";

  return (
    <LGoCard variant="raised">
      <LGoCardHeader>
        <LGoCardTitle>Upozornění v prohlížeči</LGoCardTitle>
      </LGoCardHeader>

      <LGoCardContent className="flex items-start justify-between gap-6">
        <div>
          <label htmlFor="push-notifications" className="text-base font-medium text-foreground">
            Upozorňovat na rezervace
          </label>
          <p className="mt-2 max-w-prose text-sm text-muted-foreground">{explanations[state]}</p>
        </div>
        <Switch
          id="push-notifications"
          checked={state === "on"}
          disabled={!isSwitchable || isSwitching}
          onCheckedChange={(checked) => (checked ? onEnable() : onDisable())}
          aria-label="Upozorňovat na rezervace"
        />
      </LGoCardContent>
    </LGoCard>
  );
}
